import React from 'react';

const VALORIZA_LOGO_URL = "https://customer-assets.emergentagent.com/job_workday-intelligence/artifacts/qhr4asee_VALORIZA_color_negativo.svg";

/**
 * Reusable Valoriza branding component
 * Supports multiple sizes and placements following design guidelines
 */
export const ValorizaBrandMark = ({ size = 'md', placement = 'sidebar', showPoweredBy = false, collapsed = false }) => {
  const sizeMap = {
    sm: { height: '20px', text: 'text-[10px]' },
    md: { height: '28px', text: 'text-xs' },
    lg: { height: '40px', text: 'text-sm' }
  };

  const config = sizeMap[size] || sizeMap.md;

  // Sidebar placement with full brand block
  if (placement === 'sidebar' && !collapsed) {
    return (
      <div className="flex flex-col gap-2 px-4 py-4">
        <a
          href="/"
          className="flex items-center gap-3 rounded-lg hover:bg-slate-800/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/60 transition-colors duration-200"
          data-testid="valoriza-sidebar-brand-link"
        >
          <img
            src={VALORIZA_LOGO_URL}
            alt="Valoriza"
            className="h-7 w-auto"
            data-testid="valoriza-sidebar-logo"
          />
          <div className="min-w-0 flex-1">
            <div className="text-sm font-semibold leading-tight text-slate-100 truncate">
              SmartClockIn
            </div>
          </div>
        </a>
        
        {/* Powered by - Centered with rocket */}
        <div 
          className="flex items-center justify-center gap-2 py-2 px-2 bg-slate-800/30 rounded-lg border border-slate-700/50"
          data-testid="valoriza-sidebar-powered-by"
        >
          <span className="text-lg">🚀</span>
          <span className="text-[10px] text-slate-400 tracking-wide font-medium">
            Powered by Valoriza's Innovation Team
          </span>
        </div>
      </div>
    );
  }

  // Sidebar collapsed: logo only with tooltip
  if (placement === 'sidebar' && collapsed) {
    return (
      <a
        href="/"
        className="flex items-center justify-center px-4 py-4 rounded-lg hover:bg-slate-800/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/60 transition-colors duration-200"
        data-testid="valoriza-sidebar-brand-link"
        title="SmartClockIn - Powered by Valoriza's Innovation Team"
      >
        <img
          src={VALORIZA_LOGO_URL}
          alt="Valoriza"
          className="h-7 w-auto"
          data-testid="valoriza-sidebar-logo"
        />
      </a>
    );
  }

  // Login placement: centered, larger with rocket
  if (placement === 'login') {
    return (
      <div className="flex flex-col items-center mb-6" data-testid="valoriza-login-brand">
        <img
          src={VALORIZA_LOGO_URL}
          alt="Valoriza"
          className="h-10 w-auto mb-4"
          data-testid="valoriza-login-logo"
        />
        {showPoweredBy && (
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800/30 rounded-lg border border-slate-700/50" data-testid="valoriza-login-powered-by">
            <span className="text-lg">🚀</span>
            <p className="text-xs text-slate-400 tracking-wide font-medium m-0">
              Powered by Valoriza's Innovation Team
            </p>
          </div>
        )}
      </div>
    );
  }

  // Topbar placement: small mark with divider
  if (placement === 'topbar') {
    return (
      <div className="flex items-center gap-3" data-testid="valoriza-topbar-brand">
        <img
          src={VALORIZA_LOGO_URL}
          alt="Valoriza"
          className="h-5 w-auto"
          data-testid="valoriza-topbar-logo"
        />
        <div className="h-5 w-px bg-slate-700/70" aria-hidden="true" />
      </div>
    );
  }

  // Generic placement: logo only
  return (
    <img
      src={VALORIZA_LOGO_URL}
      alt="Valoriza"
      style={{ height: config.height, width: 'auto' }}
      data-testid="valoriza-logo"
    />
  );
};

/**
 * Powered by text component for footer/standalone use
 */
export const ValorizaPoweredBy = ({ className = '' }) => {
  return (
    <div
      className={`flex items-center justify-center gap-2 pt-3 mt-3 border-t border-slate-700/60 ${className}`}
      data-testid="valoriza-powered-by-section"
    >
      <span className="text-base">🚀</span>
      <p className="text-xs text-slate-400 tracking-wide text-center m-0" data-testid="valoriza-powered-by">
        Powered by Valoriza's Innovation Team
      </p>
    </div>
  );
};
